import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { financialReportKeys, transactionKeys } from '@/lib/query-keys';
import { financialService } from '@/services/financial.service';
import type { Transaction } from '@/types/table';

/** Change a ledger row's labels. Amounts and dates aren't editable here; they move balances. */
export function useUpdateTransaction() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<Pick<Transaction, 'kind' | 'description' | 'referenceNumber' | 'invoiceId'>> }) =>
      financialService.updateTransaction(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: transactionKeys.lists() });
      queryClient.invalidateQueries({ queryKey: financialReportKeys.all });
      toast.success('Transaction updated');
    },
    onError: () => toast.error('Failed to update the transaction'),
  });
}
